import { render, staticRenderFns } from "./RecordDetailContent.vue?vue&type=template&id=d7090716&scoped=true"
import script from "./RecordDetailContent.vue?vue&type=script&lang=ts"
export * from "./RecordDetailContent.vue?vue&type=script&lang=ts"
import style0 from "./RecordDetailContent.vue?vue&type=style&index=0&id=d7090716&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7090716",
  null
  
)

export default component.exports